<template>
  <sButton
    v-if="btn && can_edit_tender"
    color="var(--white-color)"
    data-qa="btn-edit-tender"
    icon="edit"
    type="text"
    @click="open">
    {{ $t('Tenders.EditTender') }}
  </sButton>
  <MenuItem
    v-else-if="can_edit_tender"
    class="h11-links"
    data-qa="item-edit-tender"
    icon="edit"
    :label="bigFirstLetter($t('Tenders.EditTender'))"
    @click="open"/>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'
import SmarttenderApi from '@/api/smarttenderApi'
import { modalMixin, tenderMixin, userMixin } from 'mixins'

const api = new SmarttenderApi()
export default {
  name: 'returnToRegistrationConfirmation',
  mixins: [ tenderMixin, modalMixin, userMixin],
  data() {
    return {
      dialog: false,
    }
  },
  props: {
    // confirm: {
    //   type: Function,
    //   required: true
    // },
    item: {
      type: Object,
      required: true
    },
    btn: Boolean
  },
  computed: {
    status() {
      return this.item.tenderStatusId || this.item.tenderStatus.id
    },
    without_publication() {
      return this.status == 3 && this.item.biddingType?.withoutPublication
    },
    can_edit_tender() {
      if (this.$route.name === 'editTender') {
        return false
      }
      const condition = this.$acl.check('onlyTenders')
      && !this.item?.hasRoute

      return condition && (this.status == 1 || (
        (this.status == 3 || this.status == 4 || this.without_publication) && !this.item.hasBids && !this.item.participantCount && !this.item.bidsCount
      ))
    },
    sheduled_date() {
      let scheduled = this.item?.tenderPublishedSchedule
      return this.status == 1  && scheduled?.isScheduled && scheduled?.scheduledDate
    },
    return_to_status() {
      return this.getStatus(this.item)?.title
    },
    should_return() {
      return this.status == 3 || this.status == 4 || this.sheduled_date  || this.without_publication
    }
  },
  methods: {
    open() {
      if (this.should_return) {
        this.$Modal.confirm({
          title: this.$t('Tenders.SureToEdit'),
          content: this.$t('Tenders.SureToReturnToRegistration', {status: this.return_to_status,
            restart: this.sheduled_date ? this.smallFirstLetter(this.$t('Tenders.ToSchedule')) : this.$t('Tenders.Republish') }),
          closable: true,
          okText: this.$t('Tenders.ReturnAndEdit'),
          cancelText: this.$t('Common.Cancel'),
          loading: true,
          onOk: this.confirm,
          onCancel: this.$Modal.remove,
          width: 736
        })
      } else {
        this.confirm()
      }

    },
    close() {
      this.dialog = false
    },
    async routeTo(event, tender, link, newPage) {
      if (tender?.organizer?.organizationItId && tender?.organizer?.organizationItId != this.$route.params.org) {
        event?.preventDefault()
        event?.stopPropagation()
        if (!newPage) {
          await this.changeOrganisation({organizationItId: tender?.organizer?.organizationItId},{organizationItId: this.$route.params.org})
        }
        if (link) {
          if (newPage) {
            let routeData = this.$router.resolve(link)
            window.open(routeData.href, '_blank')
          } else {
            this.$router.push(link)
          }
        }
      }
    },
    async confirm() {
      const itemOrgId = this.item.organizer.organizationItId
      const newPage = itemOrgId !== this.storedCurrentOrganization.organizationItId

      if (!newPage) { await this.routeTo(null, this.item, null, newPage) }
      let edit = () => {
        this.$store.commit('setNewTenderInfo',   {mode: 'edit', step: 1 })
        this.$store.commit('setTender' , {})

        const newLink = {
          name: 'editTender',
          query: {id: this.item.tenderId},
          params: {
            org: newPage ? itemOrgId : this.$route.params.org
          }
        }

        if (newPage) {
          let routeData = this.$router.resolve(newLink)
          window.open(routeData.href, '_blank')
        } else {
          this.$router.push(newLink)
        }
      }
      if ( this.should_return ) {
        await api.returnToRegistration(this.item.tenderId, itemOrgId)
          .then(res => res.data.returnToRegistration && edit() )
      } else {
        edit()
      }
      this.$Modal.remove()
    }
  },
  components: {
    MenuItem
  }
}
</script>
